import { ThemeProvider, createTheme } from "@material-ui/core/styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1290d5",
    },
  },
  typography: {
    fontFamily: "'Roboto', serif",
  },
});

export const MentoroTheme = ({ children }) => (
  <ThemeProvider theme={theme}>{children}</ThemeProvider>
);
